"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProfileUpdateDto = instanceOfProfileUpdateDto;
exports.ProfileUpdateDtoFromJSON = ProfileUpdateDtoFromJSON;
exports.ProfileUpdateDtoFromJSONTyped = ProfileUpdateDtoFromJSONTyped;
exports.ProfileUpdateDtoToJSON = ProfileUpdateDtoToJSON;
exports.ProfileUpdateDtoToJSONTyped = ProfileUpdateDtoToJSONTyped;
const PhoneNumberUpdateDtoV2_1 = require("./PhoneNumberUpdateDtoV2");
const AddressUpsertDto_1 = require("./AddressUpsertDto");
/**
 * Check if a given object implements the ProfileUpdateDto interface.
 */
function instanceOfProfileUpdateDto(value) {
    return true;
}
function ProfileUpdateDtoFromJSON(json) {
    return ProfileUpdateDtoFromJSONTyped(json, false);
}
function ProfileUpdateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'dateOfBirth': json['dateOfBirth'] == null ? undefined : (new Date(json['dateOfBirth'])),
        'address': json['address'] == null ? undefined : (0, AddressUpsertDto_1.AddressUpsertDtoFromJSON)(json['address']),
        'phoneNumber': json['phoneNumber'] == null ? undefined : (0, PhoneNumberUpdateDtoV2_1.PhoneNumberUpdateDtoV2FromJSON)(json['phoneNumber']),
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
    };
}
function ProfileUpdateDtoToJSON(json) {
    return ProfileUpdateDtoToJSONTyped(json, false);
}
function ProfileUpdateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'dateOfBirth': value['dateOfBirth'] == null ? undefined : (value['dateOfBirth'].toISOString().substring(0, 10)),
        'address': (0, AddressUpsertDto_1.AddressUpsertDtoToJSON)(value['address']),
        'phoneNumber': (0, PhoneNumberUpdateDtoV2_1.PhoneNumberUpdateDtoV2ToJSON)(value['phoneNumber']),
        'ssn': value['ssn'],
    };
}
//# sourceMappingURL=ProfileUpdateDto.js.map